import React from 'react'

const Intro = () => {
    return (
        <div className='intro'>
                <h1 className=''>
                Welcome to GameCenter.com
                </h1>
                <img className='logo' src="./images/logo.jpg" alt="" />

            <h2>It is the best place to play games with your freinds</h2>
        </div>


    )
}

export default Intro